/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import State from 'shared/client/screen/state';


export default new Client ([ State ], class
{
  constructor ([ state, dispatch ])
  {
    this.state = state;
    this.dispatch = dispatch;
  }


  getWindowWidth ()
  {
    return this.state.width;
  }


  getWindowHeight ()
  {
    return this.state.height;
  }


  isOnline ()
  {
    return this.state.online;
  }


  isMobile ()
  {
    return this.getWindowWidth() < 600 || this.getWindowHeight() < 550;
  }


  isTouch ()
  {
    return ('ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  }


});
